import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { LocalizedText, RouterService } from '@mews/framework';
import { ImageResizeMode } from '@mews/enums';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { SpacingSmallTop, SpacingMediumBottom, SpacingMediumTopBottom, Select } from '@mews-commander/ui';
import { Avatar, Image, Stack, Title } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import {
    getCurrentEnterpriseServiceOptions,
    hasCurrentEnterpriseMultipleBookableServices,
} from '@mews-commander/legacy-entities/src/selectors/services';
import { changeServiceId, getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { getImageBaseUrl } from '../../app/reducers/configuration';

const EnterpriseLogo = ({
    imageBaseUrl,
    showServiceSelect,
    changeService,
    selectedServiceId,
    serviceOptions,
}: $TSFixMe) => {
    const currentEnterprise = useCurrentEnterprise();
    return (
        <SpacingSmallTop>
            <Stack data-test-id={DataTestId.EnterpriseLogo} spacing="100">
                {currentEnterprise.logoImageId ? (
                    <Image
                        src={RouterService.imageUrl(currentEnterprise.logoImageId, imageBaseUrl, {
                            mode: ImageResizeMode.FitExact,
                            width: 64,
                            height: 64,
                        })}
                    />
                ) : (
                    // @ts-expect-error $TSFixMeError: No overload matches this call.
                    <Avatar title={currentEnterprise.name} />
                )}
                <Stack itemAlignment="center">
                    <Title level={3}>{currentEnterprise.name}</Title>
                </Stack>
            </Stack>
            {showServiceSelect ? (
                <SpacingMediumTopBottom>
                    <Select
                        label={<LocalizedText textKey={TextKey.SelectService} />}
                        options={serviceOptions}
                        onChange={changeService}
                        selected={selectedServiceId}
                        data-test-id={DataTestId.ServiceSelector}
                        bottomCaption={<LocalizedText textKey={TextKey.DashboardServiceSelectCaption} />}
                        required
                    />
                </SpacingMediumTopBottom>
            ) : (
                <SpacingMediumBottom />
            )}
        </SpacingSmallTop>
    );
};

export default connect(
    createStructuredSelector<ApplicationState, $TSFixMe>({
        imageBaseUrl: getImageBaseUrl,
        selectedServiceId: getSelectedServiceId,
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        showServiceSelect: hasCurrentEnterpriseMultipleBookableServices,
        serviceOptions: getCurrentEnterpriseServiceOptions,
    }),
    {
        changeService: changeServiceId,
    }
)(EnterpriseLogo);
